export type SignupError = {
  message: string;
  statusCode?: number;
  details?: {
    code?: string;
    error?: string;
    message?: string;
  };
  response?: Response;
};

export const normalizeSignupError = (err: unknown): SignupError => {
  // Handle standard Error instances (including custom Error subclasses like FetchError)
  if (err instanceof Error || (err && typeof err === 'object')) {
    const anyErr = err as any;

    const baseMessage =
      typeof anyErr.message === 'string'
        ? anyErr.message
        : String(anyErr.message ?? 'Unknown error');

    const rawDetails = anyErr.details;
    const normalizedDetails =
      rawDetails && typeof rawDetails === 'object'
        ? {
            code:
              typeof (rawDetails as any).code === 'string'
                ? (rawDetails as any).code
                : undefined,
            error:
              typeof (rawDetails as any).error === 'string'
                ? (rawDetails as any).error
                : undefined,
            message:
              typeof (rawDetails as any).message === 'string'
                ? (rawDetails as any).message
                : undefined,
          }
        : undefined;

    return {
      message: baseMessage,
      statusCode:
        typeof anyErr.statusCode === 'number' ? anyErr.statusCode : undefined,
      details: normalizedDetails,
      response:
        anyErr.response instanceof Response ? anyErr.response : undefined,
    };
  }

  // Fallback for non-object / non-Error values (e.g. strings, numbers, null, undefined)
  return {
    message: String(err),
    details: undefined,
  };
};

export function isDuplicateEmailError(error: SignupError): boolean {
  const errorCode = error.details?.code;
  const errorMessage = error.message?.toLowerCase() || '';

  return (
    errorCode === 'DUPLICATE_EMAIL' ||
    errorMessage.includes('already exists') ||
    errorMessage.includes('already registered') ||
    errorMessage.includes('email already') ||
    errorMessage.includes('duplicate')
  );
}
